import React from 'react'
import { Link } from 'react-router-dom'

const LinkSafe = ({ title, className, to, onClick, children }) => (
  <Link title={title} to={to} children={children} className={className} onClick={onClick} />
)

export default LinkSafe
